import { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";

const SESSION_KEY = "mizban-home-splash-seen";
const MIN_VISIBLE_MS = 700;

// Shown once per browser session on the homepage: a brief white splash with
// the Mizban logo doing a deliberate entrance (scale + settle), then a soft
// fade-out that hands off to the hero's own entrance timeline in Home.jsx —
// so the two read as one continuous reveal instead of two separate
// animations competing for attention.
const HomeSplash = () => {
  const reduceMotion = useReducedMotion();
  const alreadySeen =
    typeof window !== "undefined" &&
    window.sessionStorage?.getItem(SESSION_KEY) === "1";

  const [visible, setVisible] = useState(!alreadySeen);

  useEffect(() => {
    if (alreadySeen) return undefined;

    window.sessionStorage?.setItem(SESSION_KEY, "1");

    if (reduceMotion) {
      setVisible(false);
      return undefined;
    }

    const timer = window.setTimeout(() => setVisible(false), MIN_VISIBLE_MS);
    return () => window.clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          aria-hidden="true"
          className="fixed inset-0 z-[70] flex items-center justify-center bg-white"
          initial={{ opacity: 1 }}
          exit={reduceMotion ? { opacity: 0 } : { opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
        >
          <motion.img
            src="/images/mizban.png"
            alt=""
            className="h-auto w-40 sm:w-48"
            initial={
              reduceMotion
                ? false
                : { opacity: 0, scale: 0.85, y: 14 }
            }
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default HomeSplash;
